/*
  Wishlist (no account needed). Saved product handles live in localStorage under "nt-wishlist" (JSON array).
  Markup: any button with [data-nt-wishlist-toggle][data-handle="<product handle>"] toggles that product;
          elements with [data-nt-wishlist-count] show the count (hidden when 0).
  API:    window.ntWishlist.get() / has(handle) / toggle(handle[, force]) / count() / sync([root])
  Event:  document "nt:wishlist:change" with detail { handles, count, handle, added }.
*/
(() => {
  if (window.ntWishlist) return;
  const KEY = 'nt-wishlist';

  let memory = [];
  const read = () => {
    try {
      const v = JSON.parse(localStorage.getItem(KEY) || '[]');
      memory = Array.isArray(v) ? v.filter((h) => typeof h === 'string' && h) : [];
    } catch (e) { /* storage blocked: keep the in-memory list */ }
    return memory;
  };
  const write = (list) => {
    memory = list;
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) { /* storage blocked */ }
  };
  const get = () => read().slice();
  const has = (handle) => get().includes(handle);
  const count = () => get().length;

  const emit = (extra) => {
    const handles = get();
    sync();
    document.dispatchEvent(new CustomEvent('nt:wishlist:change', { detail: Object.assign({ handles, count: handles.length }, extra) }));
  };

  const toggle = (handle, force) => {
    if (!handle) return false;
    const list = get().filter((h) => h !== handle);
    const add = typeof force === 'boolean' ? force : !has(handle);
    if (add) list.unshift(handle);
    write(list);
    emit({ handle, added: add });
    return add;
  };

  const sync = (root = document) => {
    const list = get();
    root.querySelectorAll('[data-nt-wishlist-toggle][data-handle]').forEach((btn) => {
      const on = list.includes(btn.dataset.handle);
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    document.querySelectorAll('[data-nt-wishlist-count]').forEach((el) => {
      el.textContent = list.length;
      el.hidden = list.length === 0;
    });
  };

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-nt-wishlist-toggle][data-handle]');
    if (!btn) return;
    e.preventDefault();
    toggle(btn.dataset.handle);
  });

  // Another tab changed the list.
  window.addEventListener('storage', (e) => { if (e.key === KEY) emit({}); });

  // Cards added later (load more, recommendations, theme editor) get the right state.
  let queued = false;
  const queue = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; sync(); });
  };
  const start = () => {
    sync();
    new MutationObserver((records) => {
      for (const r of records) {
        for (const n of r.addedNodes) {
          if (n.nodeType === 1 && (n.matches('[data-nt-wishlist-toggle],[data-nt-wishlist-count]') || n.querySelector('[data-nt-wishlist-toggle],[data-nt-wishlist-count]'))) { queue(); return; }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', () => sync());

  window.ntWishlist = { get, has, toggle, count, sync };
})();
